// extracted by mini-css-extract-plugin
module.exports = {"root":"DefaultLayout_root__11Qj-","pdfRoot":"DefaultLayout_pdfRoot__1UjYI","fullFrame":"DefaultLayout_fullFrame__kv6Qb","content":"DefaultLayout_content__KXu3E"};